let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("l0VRX")).then(() => parcelRequire('l0MAd'));